var _rect, _rect2, _rect3, _rect4, _rect5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1152,
    height: 1080,
    viewBox: "0 0 1152 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1152,
    height: 1080,
    transform: "matrix(-1 0 0 1 1152 0)",
    fill: "#001A33"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1152,
    height: 1080,
    transform: "matrix(-1 0 0 1 1152 0)",
    fill: "url(#paint0_radial_9711_1373)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1152,
    height: 1080,
    transform: "matrix(-1 0 0 1 1152 0)",
    fill: "url(#paint1_radial_9711_1373)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 1152,
    height: 1080,
    transform: "matrix(-1 0 0 1 1152 0)",
    fill: "url(#paint2_radial_9711_1373)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 1152,
    height: 1080,
    transform: "matrix(-1 0 0 1 1152 0)",
    fill: "url(#paint3_linear_9711_1373)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_9711_1373",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(653 1338) rotate(-122.703) scale(1948.95 1578.95)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003A99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117896,
    stopColor: "#003A99",
    stopOpacity: 0.991615
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.213837,
    stopColor: "#003A99",
    stopOpacity: 0.967585
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2912,
    stopColor: "#003A99",
    stopOpacity: 0.9296
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353363,
    stopColor: "#003A99",
    stopOpacity: 0.879348
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403704,
    stopColor: "#003A99",
    stopOpacity: 0.818519
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4456,
    stopColor: "#003A99",
    stopOpacity: 0.7488
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48243,
    stopColor: "#003A99",
    stopOpacity: 0.671881
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51757,
    stopColor: "#003A99",
    stopOpacity: 0.589452
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5544,
    stopColor: "#003A99",
    stopOpacity: 0.5032
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.596296,
    stopColor: "#003A99",
    stopOpacity: 0.414815
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.646637,
    stopColor: "#003A99",
    stopOpacity: 0.325985
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7088,
    stopColor: "#003A99",
    stopOpacity: 0.2384
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786163,
    stopColor: "#003A99",
    stopOpacity: 0.153748
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882104,
    stopColor: "#003A99",
    stopOpacity: 0.0737185
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003A99",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_9711_1373",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-408 1352) rotate(-111.718) scale(1270.16 1839.84)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F1CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117896,
    stopColor: "#7F1CBB",
    stopOpacity: 0.991615
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.213837,
    stopColor: "#7F1CBB",
    stopOpacity: 0.967585
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2912,
    stopColor: "#7F1CBB",
    stopOpacity: 0.9296
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353363,
    stopColor: "#7F1CBB",
    stopOpacity: 0.879348
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403704,
    stopColor: "#7F1CBB",
    stopOpacity: 0.818519
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4456,
    stopColor: "#7F1CBB",
    stopOpacity: 0.7488
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48243,
    stopColor: "#7F1CBB",
    stopOpacity: 0.671881
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51757,
    stopColor: "#7F1CBB",
    stopOpacity: 0.589452
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5544,
    stopColor: "#7F1CBB",
    stopOpacity: 0.5032
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.596296,
    stopColor: "#7F1CBB",
    stopOpacity: 0.414815
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.646637,
    stopColor: "#7F1CBB",
    stopOpacity: 0.325985
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7088,
    stopColor: "#7F1CBB",
    stopOpacity: 0.2384
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786163,
    stopColor: "#7F1CBB",
    stopOpacity: 0.153748
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882104,
    stopColor: "#7F1CBB",
    stopOpacity: 0.0737185
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F1CBB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_9711_1373",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-316 1118) rotate(-43.8345) scale(903.87 751.764)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24DBB7",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117896,
    stopColor: "#24DBB7",
    stopOpacity: 0.981783
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.213837,
    stopColor: "#24DBB7",
    stopOpacity: 0.958233
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2912,
    stopColor: "#24DBB7",
    stopOpacity: 0.921008
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353363,
    stopColor: "#24DBB7",
    stopOpacity: 0.871761
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403704,
    stopColor: "#24DBB7",
    stopOpacity: 0.812148
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4456,
    stopColor: "#24DBB7",
    stopOpacity: 0.743824
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48243,
    stopColor: "#24DBB7",
    stopOpacity: 0.668444
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51757,
    stopColor: "#24DBB7",
    stopOpacity: 0.587663
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5544,
    stopColor: "#24DBB7",
    stopOpacity: 0.503136
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.596296,
    stopColor: "#24DBB7",
    stopOpacity: 0.416519
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.646637,
    stopColor: "#24DBB7",
    stopOpacity: 0.329465
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7088,
    stopColor: "#24DBB7",
    stopOpacity: 0.243632
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786163,
    stopColor: "#24DBB7",
    stopOpacity: 0.160673
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882104,
    stopColor: "#24DBB7",
    stopOpacity: 0.0822442
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24DBB7",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9711_1373",
    x1: 138,
    y1: 1506,
    x2: 502,
    y2: 796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA726",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117896,
    stopColor: "#FFA726",
    stopOpacity: 0.981783
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.213837,
    stopColor: "#FFA726",
    stopOpacity: 0.958233
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2912,
    stopColor: "#FFA726",
    stopOpacity: 0.921008
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353363,
    stopColor: "#FFA726",
    stopOpacity: 0.871761
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403704,
    stopColor: "#FFA726",
    stopOpacity: 0.812148
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4456,
    stopColor: "#FFA726",
    stopOpacity: 0.743824
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48243,
    stopColor: "#FFA726",
    stopOpacity: 0.668444
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51757,
    stopColor: "#FFA726",
    stopOpacity: 0.587663
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5544,
    stopColor: "#FFA726",
    stopOpacity: 0.503136
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.596296,
    stopColor: "#FFA726",
    stopOpacity: 0.416519
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.646637,
    stopColor: "#FFA726",
    stopOpacity: 0.329465
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7088,
    stopColor: "#FFA726",
    stopOpacity: 0.243632
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786163,
    stopColor: "#FFA726",
    stopOpacity: 0.160673
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882104,
    stopColor: "#FFA726",
    stopOpacity: 0.0822442
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA726",
    stopOpacity: 0.01
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.c50b8b453214b505db187ce7aa8264dd.svg";
export { ForwardRef as ReactComponent };